import type { UseQueryOptions } from '@tanstack/react-query';

import { type Blueprint, getBlueprint, type KyInstance } from '@enterprise/api';
import type { OperationResultWithData } from '@enterprise/types';

import { datastreamQueryKeys } from '@/common/query-keys';

export const createBlueprintDetailQuery = (
  instance: KyInstance,
  id: number
): UseQueryOptions<OperationResultWithData<Blueprint>, Error, Blueprint | null> => {
  return {
    queryFn: async () => {
      return getBlueprint(instance, id);
    },
    queryKey: datastreamQueryKeys.blueprints.byId(id),
    select: (result) => {
      if (result.failure) {
        return null;
      }

      return result.data;
    },
  };
};
